import { createContext, useContext } from 'react';

import { RouterContextState } from './types';

export const RouterContext = createContext<RouterContextState>(null!);

export function useRouter<T = {}>() {
	return useContext(RouterContext) as RouterContextState<T>;
}
